import(/* webpackMode: "eager" */ "/build/src/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/LoggerInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/MuiXLicense.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalUIProvider"] */ "/build/src/components/providers/GlobalUIProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/providers/ThemeRegistry.tsx");
